<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs6 offset-xs3>
        <h1>Register</h1>
     
        <v-text-field
          
          placeholder="Email"
          :value="emailRegistered"
          @input="setEmailRegistered"
        ></v-text-field> 
        <v-text-field
          
          type="password"
          autocomplete="new-password"
          placeholder="Password"
          :value="passwordRegistered"
          @input="setPasswordRegistered"
        ></v-text-field>     
        <v-alert type="error" :value="registerError">{{registerError}}</v-alert>
     
        <v-btn color="green" @click="register" dark>Register</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  mounted() {
    /*this.fetchDocumentsEs();
    this.fetchDocumentsPgres();
    this.fetchDocumentsOracle();*/
  },
  components: {},
  computed: {
    ...mapState("authentication", ["emailRegistered", "passwordRegistered","registerError"])
  },
  methods: {
    ...mapActions("authentication", ["register"]),
    ...mapMutations("authentication", [
      "setEmailRegistered",
      "setPasswordRegistered"
    ])
  }
};
</script>
